<template lang="pug">
v-container
    v-btn(
        color="secondary"
        block
        :dark="!loading"
        :disabled="loading"
        @click="showModal = true"
        )
        v-icon(left) search
        span BUSCAR CLIENTE
    v-btn(
        color="success"
        block
        :dark="!loading"
        :disabled="loading"
        @click="handleCreate()"
        )
        v-icon(left) add
        span CREAR CLIENTE
    // Agregar 
        :ground-seller-id="groundSellerId"
    customer-search(
        @customer:set="handleSearch($event)"
        v-model="showModal"
        mobile
      )
      template(slot="toolbar-tail")
        .d-flex.pr-3.pt-3
          v-switch(
            label="Traer datos faltantes desde S.I.I."
            v-model="completeFromSii"
            )
    v-form(ref="form" v-if="showForm")
        RUTInput.mt-4( 
            label="RUT"
            v-model="rut"
            :readonly="!createMode"
            :rules="[mixRules.required]"
            :disabled="loading"
            )
        v-text-field( 
            label="Nombre"
            v-model="personName"
            :readonly="!createMode"
            :rules="[mixRules.required]"
            :disabled="loading"
            )
        v-text-field( 
            label="Razón Social"
            v-model="businessName"
            :readonly="!createMode"
            :rules="[mixRules.required]"
            :disabled="loading"
            )
        v-autocomplete(
          v-if="createMode"
          label="Giro"
          v-model="selectedCoreBusinessList"
          :rules="[v => !!v && v.length || 'Debe elgir al menos uno']"
          :items="coreBusinessList"
          item-text="core_business"
          item-value="id"
          multiple
          chips
          deletable-chips
          )
        v-layout(
          v-else-if="customerData && customerData.id"
          )
          v-flex.xs11
            v-autocomplete(
              label="Giro"
              v-model="selectedCoreBusiness"
              :rules="[mixRules.required]"
              :items="customerData ? customerData.g_core_business_sii : []"
              item-text="core_business"
              item-value="id"
              )
          v-flex.xs1
              v-btn.primary(
                @click="showCoreBusinesModal = true"
                icon
                )
                v-icon edit
        v-select(
            :items="officeOptions"
            label="Sucursal"
            placeholder="Seleccone una sucursal"
            v-model="selectedOffice"
            v-if="!createMode"
            :rules="[mixRules.required]"
            :disabled="loading"
            @change='refreshSales()'
            )
        template(v-else)
            v-autocomplete(
                :items="communeOptions"
                v-model="selectedCommune"
                label="Comuna"
                :rules="[mixRules.required]"
                :disabled="loading"
                )
            v-autocomplete(
                :items="cityOptions"
                v-model="city"
                label="Ciudad"
                :rules="[mixRules.required]"
                :disabled="loading"
                )
            v-text-field( 
                v-model="zone"
                label="Sector"
                :rules="[mixRules.required]"
                :disabled="loading"
                )
            v-text-field( 
                label="Dirección"
                v-model="address"
                :rules="[mixRules.required]"
                :disabled="loading"
                )
            v-text-field( 
                label="Fono"
                v-model="phone"
                prefix="+56"
                :disabled="loading"
                )
            v-text-field( 
                label="Email"
                v-model="email"
                :rules="[mixRules.email, mixRules.required]"
                :disabled="loading"
                )
            v-btn(
                color="success"
                block
                :dark="!loading"
                :disabled="loading"
                @click="handleSubmit()"
                )
                v-icon(left) save
                span GUARDAR
    template(
      v-if="customerData && (customerData.max_customer_credit_amount || customerData.max_customer_credit_amount === 0)"
      )
      h3 Cupo: 
      span.font-weight-bold Máximo: {{maxCredit}}
      br
      span.font-weight-bold Utilizado: {{usedCredit}}
      br
      span.font-weight-bold Disponible: {{availableCredit}}
      //-br
      //-span.font-weight-bold Disponible + Sobregiro: {{maxAvailableCredit}}
    template(v-if="showForm")
        h2.mt-3.grey--text.text--darken-3 Últimas Ventas
        div( style='height: 400px; max-height: 400px; overflow-y: scroll;' )
            v-expansion-panel
                v-expansion-panel-content(
                    v-for="sale in customerSales"
                    )
                    div(slot="header")
                        v-layout(wrap)
                            v-flex.xs6 {{ sale.createdAt }}
                            v-flex.xs6.text-xs-right.pr-3 {{sale.total | mixFormatCurrency}}
                            v-flex.xs6 
                                span {{ sale.id ? "N° " : "" }}
                                span {{ sale.folio || 'NF' }}
                            v-flex.xs6.text-xs-right.pr-3 SD: {{sale.dispatchRequest ? sale.dispatchRequest.id : ''}}
                    v-list
                        v-list-tile(v-for="detail in sale.details")
                            MobileCartItem(:item="formatSaleDetail(detail)") 

        CoreBusinessModal(
          v-if="customerData.id"
          :customer="customerData"
          v-model="showCoreBusinesModal"
          :core-business-list="coreBusinessList"
          @customer:edited="updateCustomer"
          fullscreen
          )
</template>

<script>
import CustomerSearch from '@/components/CustomerSearch/CustomerSearch'
import { mapActions, mapState, mapGetters } from 'vuex'
import RUTInput from '@/components/RUTInput/RUTInput'
import InputValidations from '../../mixins/InputValidations'
//import GCommune from '../../models/General/GCommune'
import SlCustomer from '../../models/Sale/SlCustomer'
import PosSale from '../../models/POS/PosSale'
import CurrencyUtils from '../../mixins/CurrencyUtils'
import MobileCartItem from '../MobileCart/MobileCartItem'
import GUserSeller from '../../models/General/GUserSeller'
import { cloneDeep } from 'lodash'
import CoreBusinessModal from '../../components/CoreBusinessModal/CoreBusinessModal'

// services
import PosLastSalesService from '@/services/API/POS/PosLastSales'

function initialState() {
    return {
        showModal: false,
        loading: false,

        //form data
        rut: '',
        personName: '',
        businessName: '',
        coreBusiness: '',
        officeOptions: [],
        selectedOffice: null,

        //create only data
        selectedCommune: null,
        address: '',
        phone: '',
        email: '',
        city: 'La Serena',
        zone: '',

        customerSales: [],

        selectedCoreBusinessList: [],
        showCoreBusinesModal: false,
        completeFromSii: false,
    }
}

export default {
    components: { CustomerSearch, RUTInput, MobileCartItem, CoreBusinessModal },
    mixins: [InputValidations, CurrencyUtils],
    data: () => initialState(),
    computed: {
        selectedCoreBusiness: {
            get() {
                if (!this.customerData) return null
                return this.customerData.active_core_business_id
            },
            set(v) {
                let customerData = cloneDeep(this.customerData)
                customerData.active_core_business_id = v
                this.setCustomerData(customerData)
            },
        },
        ...mapState('CustomerModule', {
            customerData: 'customerData',
            createMode: 'createMode',
            activeOfficeID: 'activeOfficeID',
        }),
        ...mapState('SessionModule', {
            communes: 'communes',
            cities: 'cities',
            coreBusinessList: 'coreBusinessList',
        }),
        ...mapState('AuthModule', ['groundSeller']),
        ...mapGetters('AuthModule', ['groundSellerId']),
        ...mapGetters('CustomerModule', { credit: 'activeCustomerCredit' }),
        showForm() {
            return this.customerData.id || this.createMode
        },
        communeOptions() {
            return this.communes.map(com => {
                return {
                    text: com.name,
                    value: com.id,
                }
            })
        },
        cityOptions() {
            return this.cities.map(c => {
                return {
                    text: c,
                    value: c,
                }
            })
        },
        maxCredit() {
            return this.credit && this.credit.max_customer_credit
                ? this.$options.filters.mixFormatCurrency(
                      this.credit.max_customer_credit
                  )
                : 'Sin Límite'
        },
        usedCredit() {
            return this.credit && this.credit.used_customer_credit
                ? this.$options.filters.mixFormatCurrency(
                      this.credit.used_customer_credit
                  )
                : '$0'
        },
        availableCredit() {
            return this.credit && this.credit.available_customer_credit
                ? this.$options.filters.mixFormatCurrency(
                      this.credit.available_customer_credit
                  )
                : '$0'
        },
        maxAvailableCredit() {
            return this.credit && this.credit.max_available_credit
                ? this.$options.filters.mixFormatCurrency(
                      this.credit.max_available_credit
                  )
                : '$0'
        },
    },
    methods: {
        /**
         * Get all sales between the max and min dates provides
         */
        getSales(customerId, customerBranchOfficeId) {
            PosLastSalesService.getLastByCustomerAndBranchOffice(customerId, customerBranchOfficeId).then((res) => {
                this.customerSales = res.data
            })
        },
        async handleSearch(e) {
            const response = await this.fetchCustomerData({
                field: 'id',
                value: e.id,
                fetchMissingData: this.completeFromSii,
                groundSellerId: this.groundSellerId || null,
            })
            // blocked customer
            if (response === 'block') {
                this.errorSnackbar('Cliente Bloqueado')
                return
            }
            if (response === true) {
                this.toggleCreateMode(false)
                this.assignData()
                this.successSnackbar('Cliente asignado exitosamente')
            } else {
                this.toggleCreateMode(true)
                this.$router.push('/mobile')
            }
        },
        assignData(d = this.customerData) {
            this.rut = d.rut
            this.personName = d.personName
            this.businessName = d.businessName
            this.coreBusiness = d.coreBusiness
            this.officeOptions = d.branch_offices.map(o => {
                let text = `${o.g_commune.name} - ${
                    o.city ? o.city + '- ' : ''
                }${o.address}`
                return {
                    text: text,
                    value: o.id,
                }
            })
            if (!this.officeOptions.length) return
            if (this.officeOptions.length === 1)
                this.selectedOffice = this.officeOptions[0].value
            else {
                try {
                    this.selectedOffice = d.branch_offices.find(
                        o => o.default_branch_office
                    ).id
                } catch (e) {
                    this.selectedOffice = this.officeOptions[0].value
                }
            }
            // this.fetchSales(d.id, this.selectedOffice)
            this.getSales(d.id, this.selectedOffice)
        },
        refreshSales() {
            // this.fetchSales(this.customerData.id, this.selectedOffice)
            this.getSales(this.customerData.id, this.selectedOffice)
        },
        fetchSales(id, officeId) {
            return new PosSale()
                .where('sl_customer_id', id)
                .where('sl_customer_branch_offices_id', officeId)
                .orderBy('-created_at')
                .include('pos_detail_sales.wh_product', 'wh_dispatch_request')
                .limit(15)
                .page(1)
                .get()
                .then(r => (this.customerSales = r.data))
                .catch(console.log)
        },
        formatSaleDetail(detail) {
            return {
                name: detail.name,
                alias_name: detail.alias,
                quantity: detail.quantity,
                sale_price: detail.price,
                subtotal: detail.total,
            }
        },
        handleCreate() {
            if (this.customerData && this.customerData.id)
                this.setCustomerData({})
            this.initialState()
            this.toggleCreateMode(true)
        },
        initialState() {
            Object.assign(this.$data, initialState())
            if (this.$refs.form) this.$refs.form.reset()
        },
        async handleSubmit() {
            if (this.$refs.form.validate() && this.createMode) {
                let data = {
                    rut: this.rut,
                    business_name: this.businessName,
                    alias_name: this.personName,
                    //core_business: this.coreBusiness,
                    core_business: this.selectedCoreBusinessList,
                    email_collection: this.email,
                    branch_offices: [
                        {
                            address: this.address,
                            phone: this.phone,
                            email: this.email,
                            g_commune_id: this.selectedCommune,
                            default_branch_office: true,
                            city: this.city,
                            zone: this.zone,
                        },
                    ],
                }
                this.loading = true
                let mdl = new SlCustomer(data)
                mdl.save()
                    .then(r => {
                        // Asociate the new customer to the ground seller
                        if (
                            this.groundSeller &&
                            this.groundSeller.hr_employee &&
                            this.groundSeller.hr_employee.id
                        )
                            new GUserSeller()
                                .include('hr_employee.g_branch_office')
                                .append('customers', 'seller_type')
                                .find(this.groundSeller.hr_employee.id)
                                .then(seller => {
                                    let customers = cloneDeep(seller.customers)
                                    customers = customers.map(
                                        customer => customer.id
                                    )
                                    let employee = cloneDeep(seller.hr_employee)
                                    delete seller.hr_employee
                                    Object.assign(seller, {
                                        rut: employee.rut,
                                        names: employee.names,
                                        last_name1: employee.last_name1,
                                        email: employee.email,
                                        g_branch_office_id:
                                            employee.g_branch_office_id,
                                    })
                                    if (customers.includes(r.customer_id))
                                        return
                                    customers.push(r.customer_id)
                                    seller.customers = customers
                                    seller
                                        .save()
                                        .then(console.log)
                                        .catch(console.log)
                                })
                                .catch(e => {
                                    let message =
                                        e.response &&
                                        e.response.data &&
                                        e.response.data.error
                                            ? e.response.data.error
                                            : 'Ha ocurrido un error'
                                    this.errorSnackbar(message)
                                    this.loading = false
                                })
                        // Fetch the newly created customer
                        this.fetchCustomerData({
                            field: 'id',
                            value: r.customer_id,
                        })
                            .then(res => {
                                this.loading = false
                                this.successSnackbar(
                                    'Cliente creado extiosamente'
                                )
                                this.$router.push('/mobile')
                                this.toggleCreateMode(false)
                            })
                            .catch(e => {
                                this.successSnackbar(
                                    'Cliente creado extiosamente'
                                )
                                this.loading = false
                            })
                    })
                    .catch(e => {
                        let message =
                            e.response &&
                            e.response.data &&
                            e.response.data.error
                                ? e.response.data.error
                                : 'Ha ocurrido un error'
                        this.errorSnackbar(message)
                        this.loading = false
                    })
            }
        },
        updateCustomer(customer) {
            this.fetchCustomerData({
                field: 'id',
                value: customer.id,
            })
            this.showCoreBusinesModal = false
            this.successSnackbar('Giros actualizados')
        },
        ...mapActions('CustomerModule', {
            fetchCustomerData: 'fetchCustomerData',
            toggleCreateMode: 'toggleCreateMode',
            setCustomerData: 'setCustomerData',
            setActiveOffice: 'setActiveOffice',
        }),
        ...mapActions('MobileSnackbarModule', {
            successSnackbar: 'successSnackbar',
            errorSnackbar: 'errorSnackbar',
        }),
    },
    watch: {
        /*
        customerData: {
            deep: true,
            immediate: true,
            handler(val) {
                if (!val.id) {
                    this.initialState()
                }
            },
        },
        */
        selectedOffice: {
            //immediate: true,
            handler(val) {
                this.setActiveOffice(val)
            },
        },
    },
    mounted() {
        if (this.customerData && this.customerData.id) this.assignData()
        if (this.activeOfficeID) this.selectedOffice = this.activeOfficeID
    },
}
</script>

<style lang="scss" scoped>
.item-layout {
    display: grid;
    grid-template-rows: 24px 24px;
    grid-template-columns: 33% 33% auto;
    padding: 0 10px;
    .item-name {
        grid-column-start: span 2;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding-right: 10px;
    }
    // .item-code {
    //     /*text-align: right;*/
    // }
    .item-price {
        font-weight: bold;
    }
    .item-total {
        font-weight: bold;
    }
}
</style>
